export default __webpack_public_path__ + "static/media/Cotizacion-orange.eff474f8.svg";